export enum GUEST_CONTRACT_CASE {
  APPROVE_READY = '승인_대기',
  PAY_READY = '결제_대기',
  CANCEL = '게스트_결제_전_취소',
  CANCEL_BY_HOST_NOT_APPROVE = '호스트_거절_취소',
  CONTRACT_COMPLETE = '계약_확정',
  CHECKIN = '입주_확인',
  LEAVE_CONFIRM = '중도_퇴실',
  CHECKOUT = '퇴실_확인',
  REFUND = '환불_대기',
  REFUND_COMPLETE = '환불_완료',
  EXTEND_APPROVE_READY = '연장_승인_대기',
  EXTEND_PAY_READY = '연장_결제_대기',
  EXTEND_CANCEL = '연장_미결제_취소',
}
